import React, { useState, useEffect, useRef } from 'react';
import FadeIn from './FadeIn';

const cateringPhotos = [
  "https://ik.imagekit.io/aeu02xvjgn/2020-06-10-Padua-Menu-0169.jpg",
  "https://ik.imagekit.io/aeu02xvjgn/2020-06-10-Padua-Menu-0250.jpg",
  "https://ik.imagekit.io/aeu02xvjgn/2020-06-10-Padua-Menu-0322.jpg",
  "https://ik.imagekit.io/aeu02xvjgn/2020-06-10-Padua-Menu-0292.jpg",
  "https://ik.imagekit.io/aeu02xvjgn/2020-06-10-Padua-Menu-0271.jpg",
];

const CateringCarousel = () => {
  const [current, setCurrent] = useState(0);
  const [loaded, setLoaded] = useState({});
  const timerRef = useRef(null);

  useEffect(() => {
    cateringPhotos.forEach((src, i) => {
      const img = new Image();
      img.onload = () => setLoaded(prev => ({ ...prev, [i]: true }));
      img.src = src;
    });
  }, []);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCurrent(c => (c + 1) % cateringPhotos.length);
    }, 4500);
    return () => clearInterval(timerRef.current);
  }, []);

  return (
    <div 
      className="relative w-full overflow-hidden shadow-2xl border-8 border-brand-vintage"
      style={{ height: '600px' }}
    >
      {cateringPhotos.map((src, i) => (
        <img
          key={i}
          src={src}
          alt={`Wedding catering and culinary experience photo ${i + 1}`}
          loading={i === 0 ? "eager" : "lazy"}
          className="absolute inset-0 w-full h-full object-cover"
          style={{
            opacity: i === current ? 1 : 0,
            transform: i === current ? 'scale(1.05)' : 'scale(1)',
            transition: 'opacity 1s ease-in-out, transform 6s ease-out',
            zIndex: i === current ? 1 : 0,
          }}
        />
      ))}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {cateringPhotos.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            aria-label={`Photo ${i + 1}`}
            className={`h-1 rounded-full transition-all duration-500 ${i === current ? 'bg-brand-vintage w-8' : 'bg-brand-vintage/50 w-2 hover:bg-brand-vintage'}`}
          />
        ))}
      </div>
    </div>
  );
};

const Catering = () => {
  return (
    <section id="catering" className="py-32 md:py-48 bg-brand-aged px-6 relative">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-brand-stone/5 pointer-events-none" />
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          <FadeIn className="order-2 lg:order-1">
            <CateringCarousel />
          </FadeIn>
          
          <FadeIn delay={0.2} className="order-1 lg:order-2">
            <span className="text-brand-olive uppercase tracking-[0.3em] text-[10px] font-bold mb-6 block">
              The Culinary Experience
            </span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-brand-charcoal mb-10 leading-[1.1] font-light">
              Elevated wedding catering designed to be <span className="italic text-brand-bronze">remembered</span>
            </h2>
            <p className="font-sans text-brand-charcoal/80 leading-relaxed font-light mb-10 text-lg tracking-wide">
              We believe the food at your wedding should rival your favorite restaurant. Our dedicated catering team provides elevated hospitality, impeccable presentation, and a guest-centered food experience that feels distinctly premium.
            </p>
            
            <div className="space-y-8 mb-14">
              {[
                { title: "Elevated Plated Service", desc: "Artfully designed dishes and catering menus for formal, multi-course celebrations." },
                { title: "Cultural Flexibility", desc: "Authentic, culturally diverse culinary options tailored to your family's traditions." },
                { title: "Curated Cocktail Hours", desc: "Hand-passed hors d'oeuvres and premium bar experiences on the sunset terrace." },
              ].map((item, i) => (
                <div key={i} className="flex gap-6 group">
                  <div className="w-8 h-[1px] bg-brand-bronze mt-3 shrink-0 group-hover:w-12 transition-all duration-500" />
                  <div>
                    <h4 className="font-serif text-xl text-brand-charcoal mb-2 font-light">{item.title}</h4>
                    <p className="font-sans text-sm text-brand-charcoal/70 leading-relaxed tracking-wide font-light">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            
            <a 
              href="#contact" 
              className="inline-block bg-brand-olive text-brand-vintage px-10 py-4.5 text-[10px] uppercase tracking-[0.25em] hover:bg-brand-charcoal transition-all font-bold shadow-xl border border-transparent hover:border-brand-vintage/20"
            >
              Ask About Your Event
            </a>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default Catering;